(() => {
  'use strict';
  if (!document.querySelector('[data-jaemi-page], [data-jaemi-header]')) return;
  const initialized = new WeakSet();
  const initializedTracks = new WeakSet();
  function initializeCarousels() {
    document.querySelectorAll('[data-jaemi-carousel-track]').forEach((track) => {
      if (initializedTracks.has(track)) return;
      initializedTracks.add(track);
      let drag = null;
      let suppressClick = false;
      track.addEventListener('dragstart', (event) => event.preventDefault());
      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (desktopMedia.matches && track.dataset.jaemiCardCount === '2') return;
        suppressClick = false;
        drag = { id: event.pointerId, x: event.clientX, scroll: track.scrollLeft, moved: false };
      });
      track.addEventListener('pointermove', (event) => {
        if (!drag || drag.id !== event.pointerId) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) <= 6) return;
        drag.moved = true;
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
        track.scrollLeft = drag.scroll - distance;
        event.preventDefault();
      });
      const finish = () => {
        if (!drag) return;
        suppressClick = drag.moved;
        drag = null;
        track.classList.remove('is-dragging');
      };
      track.addEventListener('pointerup', finish);
      track.addEventListener('pointercancel', finish);
      track.addEventListener('lostpointercapture', finish);
      track.addEventListener('pointerleave', () => { if (drag && !drag.moved) finish(); });
      track.addEventListener('click', (event) => {
        if (suppressClick && event.detail !== 0) {
          event.preventDefault();
          event.stopPropagation();
        }
        suppressClick = false;
      }, true);
    });
  }
  const desktopMedia = window.matchMedia('(min-width: 768px)');
  function syncHeroVideos() {
    document.querySelectorAll('[data-jaemi-hero-media]').forEach((media) => {
      const active = (media.dataset.jaemiHeroMedia === 'desktop') === desktopMedia.matches;
      let video = media.querySelector('video');
      const template = media.querySelector('[data-jaemi-video-template]');
      if (active && !video && template) {
        media.appendChild(template.content.cloneNode(true));
        video = media.querySelector('video');
      }
      if (!video) return;
      video.muted = true;
      if (active) {
        const playback = video.play();
        if (playback) playback.catch(() => {});
      } else {
        video.pause();
      }
    });
  }

  const searchForms = new WeakSet();
  const searchDialogs = new WeakSet();
  function initializeSearch() {
    const onResults = !!document.querySelector('[data-jaemi-search-results]');
    const params = new URLSearchParams(window.location.search);
    document.querySelectorAll('[data-jaemi-search-form]').forEach((form) => {
      if (searchForms.has(form)) return;
      searchForms.add(form);
      const scope = form.elements.namedItem('filter.p.vendor');
      if (onResults) scope.checked = params.getAll('filter.p.vendor').includes('jaemi');
      const sort = form.elements.namedItem('sort_by');
      if (!sort && onResults && params.has('sort_by')) {
        const hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'sort_by'; hidden.value = params.get('sort_by');
        form.appendChild(hidden);
      }
      // Keep an existing preview context without introducing a store/theme ID.
      if (params.has('preview_theme_id')) {
        const preview = document.createElement('input');
        preview.type = 'hidden'; preview.name = 'preview_theme_id'; preview.value = params.get('preview_theme_id');
        form.appendChild(preview);
      }
      form.addEventListener('submit', (event) => {
        const input = form.elements.namedItem('q');
        input.value = input.value.trim();
        if (!input.value) { event.preventDefault(); input.focus(); }
      });
    });
    document.querySelectorAll('[data-jaemi-search-page]').forEach((link) => {
      const original = new URL(link.href);
      const target = new URL(window.location.href);
      target.searchParams.set('page', original.searchParams.get('page') || '1');
      target.searchParams.set('view', 'jaemi');
      target.searchParams.set('type', 'product');
      target.hash = '';
      link.href = target.href;
    });
    document.querySelectorAll('[data-jaemi-header]').forEach((header) => {
      const dialog = header.querySelector('[data-jaemi-search-dialog]');
      const toggle = header.querySelector('[data-jaemi-search-open]');
      if (!dialog || !toggle || searchDialogs.has(dialog)) return;
      searchDialogs.add(dialog);
      const close = () => dialog.close();
      toggle.addEventListener('click', () => {
        const menu = header.querySelector('[data-jaemi-menu]');
        if (!desktopMedia.matches && menu) menu.open = false;
        dialog.showModal();
        toggle.setAttribute('aria-expanded', 'true');
        dialog.querySelector('[data-jaemi-query]').focus();
      });
      dialog.querySelector('[data-jaemi-search-close]').addEventListener('click', close);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
      });
      dialog.addEventListener('close', () => {
        toggle.setAttribute('aria-expanded', 'false');
        if (toggle.isConnected) toggle.focus();
      });
      // Native modal dialog handles Escape, focus containment and background inertness.
    });
  }

  function initialize() {
    initializeSearch();
    initializeCarousels();
    syncHeroVideos();
    document.querySelectorAll('[data-jaemi-header]').forEach((header) => {
      if (initialized.has(header)) return;
      const menu = header.querySelector('[data-jaemi-menu]');
      if (!menu) return;
      initialized.add(header);
      const isDesktop = () => window.matchMedia('(min-width: 768px)').matches;
      menu.open = isDesktop();
      header.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open && !isDesktop()) {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
      header.addEventListener('click', (event) => {
        if (event.target.closest('a') && !isDesktop()) menu.open = false;
      });
    });
  }
  initialize();
  window.matchMedia('(min-width: 768px)').addEventListener('change', (event) => {
    document.querySelectorAll('[data-jaemi-header] [data-jaemi-menu]').forEach((menu) => {
      menu.open = event.matches;
    });
  });
  document.addEventListener('shopify:section:load', initialize);
  desktopMedia.addEventListener('change', syncHeroVideos);
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.jaemi-hero-video').forEach((video) => video.pause());
  });
})();
